import React from 'react';
import {ViewMode} from '../models/viewMode';

export const ViewModeContext = React.createContext({
  viewMode: ViewMode.BASE,
  changeViewMode: (viewMode: ViewMode) => {}
});
